
import React from 'react';
import { Check } from 'lucide-react';

const ShopwareBenefits = () => {
  const benefits = [
    {
      title: "Skalierbare B2B & B2C-Lösungen",
      description: "Wachstum ohne Limitierungen."
    },
    {
      title: "Individuelles Shop-Design & UX-Optimierung",
      description: "für höhere Conversion-Raten."
    },
    {
      title: "Nahtlose ERP-, CRM- & PIM-Integration",
      description: "für effiziente Workflows."
    },
    {
      title: "Hohe Performance & Ladegeschwindigkeit",
      description: "bessere SEO & weniger Absprünge."
    },
    {
      title: "Mobile-Optimierung (Mobile First)",
      description: "optimal für Smartphones & Tablets."
    },
    {
      title: "Omnichannel-Strategien",
      description: "Anbindung an Marktplätze & Social Commerce."
    },
    {
      title: "Persönlicher Support & Beratung",
      description: "von Planung bis Livegang & Wartung."
    },
    {
      title: "Automatisierte Prozesse & Workflows",
      description: "effizienteres Arbeiten."
    },
    {
      title: "SEO & Marketing-Optimierung",
      description: "für mehr Sichtbarkeit und bessere Rankings."
    },
    {
      title: "Kontinuierliche Weiterentwicklung",
      description: "immer auf dem neuesten Stand."
    }
  ];

  return (
    <section className="py-16 md:py-24">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            10 Gründe für Shopware mit uns als Agentur
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Profitiere von unserer Expertise und maßgeschneiderten Lösungen für deinen E-Commerce-Erfolg
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start bg-white p-5 rounded-lg border border-gray-100 hover:shadow-md transition-all duration-300">
              <div className="rounded-full bg-green-100 p-1 mr-3 flex-shrink-0">
                <Check className="h-5 w-5 text-green-600" />
              </div>
              <div>
                <h3 className="font-bold mb-1">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShopwareBenefits;
